import React from 'react';
import { TableHead, TableCell, TableRow } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ColumnDefinitionType } from './type';

type TProps = {
  minWidth: number | undefined;
};

const useTableCellStyles = makeStyles((theme) => ({
  root: {
    minWidth: (mProp: TProps) => mProp.minWidth,
    padding: theme.spacing(1, 2, 1, 2),
    backgroundColor: theme.palette.timesheetLabelTable.headerBackgroundColor,
    color: theme.palette.grey[700]
  }
}));

type TableHeaderProps<T, K extends keyof T> = {
  columns: Array<ColumnDefinitionType<T, K>>;
};

type TableCellProps<T, K extends keyof T> = {
  column: ColumnDefinitionType<T, K>;
};

const Cell = <T, K extends keyof T>({
  column
}: TableCellProps<T, K>): React.ReactElement => {
  const classes = useTableCellStyles({ minWidth: column.minWidth });

  return (
    <TableCell
      data-testid={`table-head-cell-${column.id}`}
      key={column.id}
      align={column.align}
      classes={classes}
    >
      {column.label}
    </TableCell>
  );
};

const TableHeader = <T, K extends keyof T>({
  columns
}: TableHeaderProps<T, K>): React.ReactElement => {
  return (
    <TableHead data-testid="table-head">
      <TableRow>
        {columns.map((column) => (
          <Cell key={column.id} column={column} />
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
